import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Column = styled.div`
  border: 1px solid #e6ecf1;
  border-radius: 10px;
  padding: 16px;
  background: #ffffff;
`;

export const Title = styled.h4`
  margin: 0 0 16px 0;
  color: #1a1a1a;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
  padding: 12px;
  border: 1px solid #edf1f5;
  border-radius: 8px;
  background: #fbfdff;
`;

export const RowInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Name = styled.span`
  font-weight: 700;
  color: #1a1a1a;
`;

export const Meta = styled.span`
  color: #707070;
  font-size: 12px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const SmallButton = styled.button`
  border: 1px solid #d1dbe5;
  border-radius: 6px;
  background: #ffffff;
  padding: 6px 10px;
  cursor: pointer;
  color: #1a1a1a;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const EmptyState = styled.p`
  color: #707070;
  margin: 0;
`;
